import { gql } from '@apollo/client'

export const QUERY_CHANNELS = gql`
  query channels {
    channels @client {
      id
      service
      serviceId
      organizationId
      name
      avatar
      isDisconnected
      totalComments
      totalPendingComments
      labelsCount {
        label
        count
      }
      backfillingComplete
      emojis
      updatedAt
    }
  }
`

export const QUERY_CURRENT_CHANNEL = gql`
  query currentChannel {
    currentChannel @client {
      id
      service
      serviceId
      organizationId
      name
      avatar
      isDisconnected
      totalComments
      totalPendingComments
      labelsCount {
        label
        count
      }
      backfillingComplete
      emojis
      updatedAt
    }
  }
`

export const QUERY_CURRENT_POST = gql`
  query currentPost {
    currentPost @client {
      id
      channelId
      engageCompleted
      totalPendingComments
      createdAt
      commentsUpdatedAt
      fallbackImg
    }
  }
`
